import IMA from './ABI/IMA.json'
import ISENDS from './ABI/ISENDS.json'
import IPair from './ABI/IPair.json'
import IToken from './ABI/IToken.json'
import {
    USDT,
    CVC,
    MA,
    CVCD,
    AI_TOKEN,
    USDT_CVC,
    TREASURY,
    SWAP,
    SENDS,
    MultiCallAddress
} from './contract'

import {
    OnBlock,
    WeiToUnits,
    EtherToWei,
    Erc20,
    MultiCall,
    CreateProviderForRpc,
    GetGlobalSigner,
    CreateContract,
    DEFAULT_ACCOUNT,
    BN,
    // SignApproves,
    SwitchChain,
    Approves,
    BigToString,
    ZERO_ADDRESS,
    BYTES
} from '../ethers/e'

import {MA_V2} from './v2/network'

const bytesEmpty = BYTES(64)

export const SECURITY_TREASURY = "0xe644Be7740F24098c5984DB2F52BEd97922945c8";

export function Sends() {
    return CreateContract(SENDS, ISENDS, GetGlobalSigner())
}

function Erc20Wrap(address) {
    return CreateContract(address, IToken, GetGlobalSigner())
}
export function Usdt() {
    // console.log({USDT})
    return {
        token: USDT,
        contract: Erc20(USDT[0], GetGlobalSigner())
    }
}

export function Multi() {
    return MultiCall(MultiCallAddress, GetGlobalSigner())
}

export function Cvc() {
    return {
        token: CVC,
        contract: Erc20Wrap(CVC[0])
    } 
}

export function AIToken() {
    return {
        token: AI_TOKEN,
        contract: Erc20Wrap(AI_TOKEN[0])
    }
}
function MAContract() {
    return CreateContract(MA, IMA, GetGlobalSigner())
}

function MAV2() {
    return CreateContract(MA_V2, IMA, GetGlobalSigner())
}

export function SwapContract() {
    return  CreateContract(SWAP, IMA, GetGlobalSigner())
}

function CVCPair() {
    return CreateContract(USDT_CVC, IPair, GetGlobalSigner())
}

export async function CVCPrice() {
    
    const usdtContract = Usdt()
    const cvcContract = Cvc()

    const pair = CVCPair()

    const multiCall = Multi()

    const results = await multiCall.all({
        treasuryCVC: cvcContract.contract.calls.balanceOf(TREASURY),
        usdt: usdtContract.contract.calls.balanceOf(USDT_CVC),
        cvc: cvcContract.contract.calls.balanceOf(USDT_CVC),
        lastCvcPrice: pair.calls['price'+(usdtContract.token[0] > cvcContract.token[1] ? 0 : 1)+'CumulativeLast'](),
        burnedCVC: cvcContract.contract.calls.balanceOf(ZERO_ADDRESS.slice(0,-1) + '1')
    })

    return [ results.cvc, results.usdt, results.lastCvcPrice, results.treasuryCVC , WeiToUnits(results.burnedCVC)]
}


const NODE_TYPE = {
    usdtInvested: 0,
    releaseList: [],
    totalReleaseableCVC: 0,
    releasedCVC: 0,
    releaseCycle: '--',

    rankRewardedUSDT: 0,
    totalClaim: 0,
    shareReward: 0,
    sharePercent: 0,

    tree: [],
    level2Reward: 0,
    directReward: 0,
    teamReward: 0,

    vip: 0,
    identity: 0,
    isNode: null,

    rankHeadId: '--',
    userRankId: '--',
    sponsor: ZERO_ADDRESS,
    claimCVC: 0,

    totalInvested: 0,
    rankHeadAddress: ZERO_ADDRESS,
    registed: null,
    cvcClaimable: false
}
export async function NodeData(account) {
    // const usdtContract = Usdt()
    // const cvcContract = Cvc()
    const ma = MAContract()
    const multiCall = Multi()

    const mav2 = MAV2()

    const user = '0xC982c600aB41b277B21B8222bAE834E35211b43a'
    console.log(
        await ma.cvcClaimable(account),"sdf"
    )
    // console.log(
    //     // await ma.tree(account),
    //     await ma.callStatic.claim(account),
    //     "1332132 "
    // )

    const results = await multiCall.all({
        // userOf1:  ma.calls.userOf(account),

        // a: ma.calls.checkLeader(account),
        claimCVC:  ma.calls.claimCVC(account),
        // usdt: usdtContract.contract.calls.balanceOf(USDT_CVC),
        // cvc: cvcContract.contract.calls.balanceOf(USDT_CVC),
        totalInvested: ma.calls.totalInvested(),
        // reward
        // claim: ma.calls.claim(account),
        userOf:  ma.calls.userOf(account),

        // rank and reward
        sponsor: ma.calls.sponsor(account),
        rankOf:  ma.calls.rankOf(account),
        rankHeadId: ma.calls.rankingHeadId(),
        rankHead: ma.calls.rankHead(),
        rankingAddress: ma.calls.rankingAddress(account),

        // cvc reward investBalance
        investBalance: ma.calls.investBalance(account),
        totalShare: ma.calls.totalShare(),
        tree: ma.calls.tree(account),

        rankAll: ma.calls.rankAll(),
        releaseList: ma.calls.releaseCVCList(account),
        userShareE18: ma.calls.userShareE18(account),
        vipLevel: ma.calls.currentVipOf(account),

        totalOrder: ma.calls.totalOrderInvested(),
        v2Sponsor: mav2.calls.sponsor(account),
        cvcClaimable: ma.calls.cvcClaimable(account)
    })

    console.log(results, account)
    // tree
    let teamReward = 0
    let directReward = 0;
    let level2Reward = 0;
    let tree = {}
    results.tree.forEach(v => {
        const {
            identity,
            sponsor,
            vip,
            user,
            usdtInvest
        } = v
        if (identity >= 2) {
            teamReward += 1350
        }
        const invested = WeiToUnits(usdtInvest)
        const reward = WeiToUnits(usdtInvest.div(10)) * 1
        if (sponsor === account) {
            tree[user] = {
                vip: vip + 1,
                identity,
                children: [],
                invested
            }
            directReward += reward;
        }
        else {
            level2Reward += reward;
            // console.log(tree[sponsor], sponsor)
            tree[sponsor].children.push({
                vip: vip + 1,
                user,
                identity,
                invested
            })
        }
    })

    

    tree = Object.keys(tree).map(v => {
        const {
            identity,
            vip,
            children,
            invested
        } = tree[v]
        return {
            user: v,
            identity,
            vip,
            children,
            invested
        }
    })

    // console.log(
    //     tree, " tree"
    // )

    results.claim = {
        payReward: 0,
        shareReward: 0
    }
    // reward
    const totalClaim = WeiToUnits(results.claim.payReward)

    // share
    const shareReward = WeiToUnits(results.claim.shareReward)
    const sharePercent = results.totalShare.eq(0) ? 0 : results.investBalance.invested.mul(100000).div(results.totalShare).toNumber() / 1000
    
    const vip = results.vipLevel + 1
    const identity = results.userOf.identity

    // rank
    const userRankId = results.rankingAddress.toNumber()
    const rankHeadId = results.rankHeadId.toNumber() + 1
    const sponsor = results.sponsor === ZERO_ADDRESS ? results.v2Sponsor : results.sponsor
    const rankRewardedUSDT = WeiToUnits(results.rankOf.rewardedUSDT)

    // cvc
    const claimCVC = WeiToUnits(results.claimCVC)

    const totalInvested = WeiToUnits(results.totalInvested.add(results.totalOrder).add(BN(10).pow(18).mul(100_000_000)))

    let rankHeadAddress = results.rankHead.invester
    if (rankHeadAddress === ma.address) {
        rankHeadAddress = ZERO_ADDRESS
    }

    const usdtInvested = WeiToUnits(results.releaseList.usdtBalance)
    let totalReleaseableCVC = BN(0)
    const releaseList = results.releaseList.t.map((v, i) => {
        const id = v.toNumber()
        const startAt = (new Date(id * 1000)).Format("yy/MM/dd hh:mm")
        const bal = results.releaseList.balance[i]
        totalReleaseableCVC = totalReleaseableCVC.add(bal)
        const balance = WeiToUnits(bal)
        return {
            id,
            startAt,
            balance
        }
    }).sort((a,b) => b.id - a.id)
    totalReleaseableCVC = WeiToUnits(totalReleaseableCVC)
    
    // console.log(
    //     totalReleaseableCVC,
    //     releaseList
    // )
    const releasedCVC = WeiToUnits(results.releaseList.releasedCVC)

    return {
        rankRewardedUSDT,

        totalClaim,
        shareReward,
        sharePercent,

        tree,
        level2Reward,
        directReward,
        teamReward,

        vip,
        identity,

        rankHeadId,
        userRankId,
        sponsor,
        claimCVC,
        totalInvested,
        rankHeadAddress,
        registed: sponsor !== ZERO_ADDRESS,
        isNode: results.userOf.identity !== 0,

        usdtInvested,
        releaseList,
        totalReleaseableCVC,
        releaseCycle: results.userOf.identity == 0 ? 104 : 52,
        releasedCVC,
        cvcClaimable: results.cvcClaimable
    }

}
NodeData.Type = NODE_TYPE

export function Claim(address) {
    const ma = MAContract()
    return ma.claim(address) 
}

export function ClaimCVC(address) {
    const ma = MAContract()
    return ma.claimCVC(address) 
}

export function BuyNode(sponsor, hash = bytesEmpty) {
    const ma = MAContract()
    return ma.nodeRegister(sponsor, hash)
}

export function BuyNodeV2(amount,sponsor, hash = bytesEmpty) {
    const ma = MAContract()
    return ma.nodeRegisterV2(amount, sponsor, hash)
}


export async function ApprovesUSDT() {
    const ma = MAContract()
    const CreatTokens = token => {
        return {
            token,
            isMax: true,
            sender: ma.address
        }
    }
    const tokens = [
        CreatTokens(USDT),
        // CreatTokens(CVCD)
    ]
    const {
        nonce,
        tx,
        error
    } = await Approves(tokens, {provider: GetGlobalSigner()})
    return {
        nonce,
        tx,
        error
    }
}

export async function ApprovesCVCD(sender) {
    const ma = MAContract()
    const CreatTokens = token => {
        return {
            token,
            isMax: true,
            sender: sender || ma.address
        }
    }
    const tokens = [
        // CreatTokens(USDT),
        CreatTokens(CVCD)
    ]
    const {
        nonce,
        tx,
        error
    } = await Approves(tokens, {provider: GetGlobalSigner()})
    return {
        nonce,
        tx,
        error
    }
}

export async function ApprovesAIToken(sender) {
    const ma = MAContract()
    const CreatTokens = token => {
        return {
            token,
            isMax: true,
            sender: sender || ma.address
        }
    }
    const tokens = [
        // CreatTokens(USDT),
        CreatTokens(AI_TOKEN)
    ]
    const {
        nonce,
        tx,
        error
    } = await Approves(tokens, {provider: GetGlobalSigner()})
    return {
        nonce,
        tx,
        error
    }
}


export async function ApprovesCVC(sender) {
    const CreatTokens = token => {
        return {
            token,
            isMax: true,
            sender: sender || SENDS
        }
    }
    const tokens = [
        // CreatTokens(USDT),
        CreatTokens(CVC)
    ]
    const {
        nonce,
        tx,
        error
    } = await Approves(tokens, {provider: GetGlobalSigner()})
    return {
        nonce,
        tx,
        error
    }
}


function _GetVipRate(vip) {
    let rate = vip == 51 ? 14 : 3.5 + vip * 0.2;
    return rate.toFixed(4) * 1
}

function toFixeded(num) {
    return num.toFixed(3)
    // return Math.floor(num * 1_000_000_000) / 1_000_000_000
}
function _GetCycle(newVip, intInvest, newInvest) {
    // let k = []
    // let inits = intInvest
    // for(let i = newVip; i < 52; i++) {
    //     inits = inits * (_GetVipRate(i) / 100 + 1)
    //     if (i > newVip) {
    //         inits = inits * 0.993
    //     }
    //     k.push(inits)
    // }
    // console.log(k)
    if (toFixeded((100 + _GetVipRate(newVip)) / 100 * intInvest) === toFixeded(newInvest)) return 0
    let _n = toFixeded(newInvest * 0.99)
    let i;
    for( i = 0; i < 51; i++) {
        _n = toFixeded(_n / 0.99 / (100 + _GetVipRate(newVip - i)) * 100)
        // console.log(
        //     _n,
        //     intInvest,
        //     toFixeded(intInvest)
        // )
        // console.log(
        //     (_n - toFixeded(intInvest)) ** 2 / _n
        // )
        if ((_n - toFixeded(intInvest))**2 / _n < 0.005) break;
        // if (_n == toFixeded(intInvest)) break;
    }
    return i
    
}

// console.log(
//     _GetCycle(13, 1000, 1112.36301)
// )
/// stair
const STAIR_TYPE = {
    claimStair: 0,
    registed: null,
    sponsor: ZERO_ADDRESS,
    orderNetTnvest: 0,
    totalOrderRewarded: 0,
    vip: 0,
    totalLocked: 0,
    totalRewarded: 0,
    initialVip: 0,
    initialVipRate: 0,
    maxInvestable: 0,
    vipRate: '--',
    orders: []
}
export async function StairData(address) {
    const ma = MAContract()
    const multiCall = Multi()
    const results = await multiCall.all({
        userOf: ma.calls.userOf(address),
        orders: ma.calls.getOrder(address),
        sponsor: ma.calls.sponsor(address),
        vipLevel: ma.calls.currentVipOf(address),
        currentVipOf: ma.calls.currentVipOf(address),
        claimStair: ma.calls.claimStair(address)
    })

    console.log(
        results, " results"
    )

    const sponsor = results.sponsor
    const registed = sponsor !== ZERO_ADDRESS

    const orderNetTnvest = WeiToUnits(results.userOf.orderNetTnvest)
    // from child
    const totalOrderRewarded = WeiToUnits(results.userOf.totalOrderRewarded)
    const vip = results.vipLevel + 1
    const vipRate = _GetVipRate(results.vipLevel)

    let totalLocked = BN(0)
    let totalRewarded = BN(0)

    const now = new Date() * 1
    const day7 = 7 * 24 * 3600 * 1000
    const orders = results.orders.map((v,i) => {
        
        const invested = WeiToUnits(v.newInvest)

        const startTime = v.startTime.toNumber() * 1000

        const reinvestTime = v.lastSettleTime.toNumber() * 1000
        if (reinvestTime > 0) {
            totalLocked = totalLocked.add(v.newInvest)
        }
        totalRewarded = totalRewarded.add(v.newInvest)
        
        const unlockEnd = day7 + reinvestTime
        const startDate = reinvestTime === 0 ? '--' : new Date(reinvestTime).Format('yyyy.MM.dd hh:mm')

        const unlockRemainTime = unlockEnd - now
        const vip = v.vipLevel + 1
        let vipRate = _GetVipRate(v.vipLevel)
        vipRate = vipRate.toFixed(4) * 1
        const closed = reinvestTime <= 0

        const cycle = _GetCycle(v.vipLevel, WeiToUnits(v.initialTnvest)*1, invested*1) + 1
        // (v.intInvest)
        // console.log(
        //     realReturn," realReturn"
        //     ,invested
        // )
        return {
            id: i,
            startTime,
            invested,
            startDate,
            unlockRemainTime,
            unlockEnd,
            vip,
            vipRate,
            closed,
            reinvestTime,
            cycle
        }
    })

    // console.log(results.orders, " orders")
    
    
    orders.sort((a,b) => {
        // unlockRemainTime > 0 时 从小到大排序， unlockRemainTime <= 0 时，放在后面
        if ( a.reinvestTime <= 0 || b.reinvestTime <= 0 ) {
            return -1
        }
        return a.unlockRemainTime - b.unlockRemainTime

        // if ( a.unlockRemainTime == b.unlockRemainTime ) {
        //     return -1
        // }
        // return a.unlockRemainTime - b.unlockRemainTime
    })

    totalLocked = WeiToUnits(totalLocked)
    totalRewarded = WeiToUnits(totalRewarded)
    let initialVip = results.userOf.vipLevel + 1
    let initialVipRate = _GetVipRate(initialVip - 1)

    let maxInvestable = BN(30000).mul(BN(10).pow(18)).sub(results.userOf.orderNetTnvest)
    maxInvestable = WeiToUnits(maxInvestable)

    let claimStair = WeiToUnits(results.claimStair)
    return {
        registed,
        sponsor,
        orderNetTnvest,
        totalOrderRewarded,
        vip,
        vipRate,
        initialVip,
        initialVipRate,
        orders,
        totalLocked,
        totalRewarded,
        maxInvestable,
        claimStair
    }

}
StairData.Type = STAIR_TYPE

// tokenId = 0 USDT, 1 CVCD
export function BuyOrder(tokenId, amount, sponsor, hash) {
    if (hash === '') {
        hash = bytesEmpty
    }
    const ma = MAContract()
    return ma.buyOrder(tokenId === 0 ? USDT[0] : CVCD[0], amount, sponsor, hash)
}

export function SetOrder(uid, type) {
    const ma = MAContract()
    return ma.setOrder(uid, type)
}

export function Swap(amount) {
    const ma = SwapContract()
    return ma.swap(CVCD[0], amount)
}

export function ClaimStair(address) {
    const ma = MAContract()
    return ma.claimStair(address)
}

export async function UserListOfStair(pageSize) {
    const ma = MAContract()

    const maxId = await ma.LadderOrderCount()
    let start = maxId.toNumber() - pageSize
    if (start < 1) {
        start = 1
    }
    let list = []
    const res = await ma.Users(start, pageSize)

    for (let i = 0; i < res.length; i++) {
        const r = res[i]
        list.push({
            id: i,
            user: r.user,
            vipLevel: r.vipLevel + 1,
            identity: r.identity,
            orderNetTnvest: WeiToUnits(r.orderNetTnvest),
            lastStairTime: new Date(r.lastStairTime.toNumber() * 1000).Format('yyyy.MM.dd hh:mm'),
            lastStairValue: WeiToUnits(r.lastStairValue)
        })
    }
    // list 中 根据 user 字段进行去重，保留 orderNetTnvest 最大的那一条记录
    const map = {}
    list.forEach(v => {
        if (!map[v.user] || map[v.user].orderNetTnvest < v.orderNetTnvest) {
            map[v.user] = v
        }
    })
    list = Object.values(map).sort((a,b) => b.id - a.id)
    return {
        list
    }
}

UserListOfStair.Type = {
    list: []
}


export function SendCVC(tos, amounts) {
    const sends = Sends()
    return sends.sends(CVC[0], tos, amounts) 
}

export function SendCVCD(tos, amounts) {
    const sends = Sends()
    return sends.sends(CVCD[0], tos, amounts) 
}

export function SendAIToken(tos, amounts) {
    const sends = Sends()
    return sends.sends(AI_TOKEN[0], tos, amounts) 
}



const ORDER_TYPE = {
    orders: [],
    totalWithdrawed: 0,
    totalInvet: 0,
    totalRewarded: 0,

    teamOrderNetTnvest: 0,
    totalVip: 0,
    rootRewarded: 0,
    rootRewardedStair: 0
}
export async function StairOrderCheck(root) {
    const pool = MAContract()
    async function allChildren(root) {
        const tree = {}
        const children = [root]
        let _cc = [root]
        while(true) {
            const r = _cc[0]
            const chs = await pool.userOfsponsorList(r)
            for (const element of chs) {
                tree[element] = r
            }
            children.push(...chs)
            _cc = _cc.slice(1)
            _cc.push(...chs)
            if( _cc.length == 0) {
                break;
            }
        }
        return {
            all: children,
            tree
        }
    }

    const {all, tree} = await allChildren(root)
    //  mapping(address => User) public userOf;
    // mapping(address => UserReward) public userReward;
    const multiCall = Multi()
    const results = await Promise.all([
        multiCall.all(
            all.map(v => {
                // const shareRewar = pool.calls.stairShareRewardOf(v)
                const orders = pool.calls.getOrder(v)
                return {
                    // shareRewar,
                    orders
                }
            })
        ),
        multiCall.all(
            all.map(v => pool.calls.userOf(v))
        ),
    ])

    console.log(
        results
    )

    // // node performance
    // let totalNodeInvested = BN(0) 
    // team net invested
    let teamOrderNetTnvest = BN(0)
    // the count of vip of team
    let totalVip = 0
    // root's rewarded from node
    let rootRewarded = WeiToUnits(results[1][0].rewardedUSDT)
    // root's rewarded from stair
    let rootRewardedStair = WeiToUnits(results[1][0].totalOrderRewarded)


    let totalInvet = BN(0)
    let totalWithdrawed = BN(0)
    let totalRewarded = BN(0)
    const orders = results[0].map((v, i) => {
        const address = all[i]
        let netInvest = BN(0)
        let withdrawed = BN(0)
        let rewarded = BN(0)
        v.orders.forEach(v => {
            netInvest = netInvest.add(v.initialTnvest)
            if (v.lastSettleTime.eq(0)) {
                // console.log(address, i)
                withdrawed = withdrawed.add(v.newInvest)
                // console.log(
                //     v.newInvest.sub(v.initialTnvest)
                // )
                rewarded = rewarded.add(v.newInvest.sub(v.initialTnvest))
            }
        })
        totalInvet = totalInvet.add(netInvest)
        totalWithdrawed = totalWithdrawed.add(withdrawed)
        totalRewarded = totalRewarded.add(rewarded)
        netInvest = WeiToUnits(netInvest)
        withdrawed = WeiToUnits(withdrawed)
        rewarded = WeiToUnits(rewarded)

        // node invest 
        const res = results[1][i]
        if (res.vipLevel > 0) {
            totalVip += 1
        }
        teamOrderNetTnvest = teamOrderNetTnvest.add(res.orderNetTnvest)
        return {
            address,
            sponsor: tree[address],
            netInvest,
            withdrawed,
            rewarded,
            orderNetTnvest: WeiToUnits(res.orderNetTnvest)
        }
    })

    totalWithdrawed = WeiToUnits(totalWithdrawed)
    totalInvet = WeiToUnits(totalInvet)
    totalRewarded = WeiToUnits(totalRewarded)

    teamOrderNetTnvest = WeiToUnits(teamOrderNetTnvest)
    return {
        orders,
        totalWithdrawed,
        totalInvet,
        totalRewarded,


        teamOrderNetTnvest,
        totalVip,
        rootRewarded,
        rootRewardedStair
    }
}

StairOrderCheck.Type = ORDER_TYPE
